import { render, staticRenderFns } from "./my.vue?vue&type=template&id=83a68c22&scoped=true"
import script from "./my.vue?vue&type=script&lang=js"
export * from "./my.vue?vue&type=script&lang=js"
import style0 from "./my.vue?vue&type=style&index=0&id=83a68c22&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a68c22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83a68c22')) {
      api.createRecord('83a68c22', component.options)
    } else {
      api.reload('83a68c22', component.options)
    }
    module.hot.accept("./my.vue?vue&type=template&id=83a68c22&scoped=true", function () {
      api.rerender('83a68c22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/assessment/my.vue"
export default component.exports